import React from "react"
import clsx from "clsx"
import { useTranslation } from "react-i18next"

import classes from "./OrdersTabBadge.module.scss"

const OrdersTabBadge = props => {
  const { number = 0 } = props

  const i18n = useTranslation()[1]

  const isLtr = i18n.dir(i18n.language) === "ltr"

  if (number === 0) return null

  const maxReached = number > 99

  return (
    <div
      className={clsx(
        classes["container"],
        isLtr && classes["container-ltr"],
        maxReached && classes["max"]
      )}
    >
      {maxReached ? "99+" : number}
    </div>
  )
}

export default OrdersTabBadge